import { motion } from 'framer-motion';

export default function StatsCard({
    icon,
    label,
    value,
    trend = null,
    trendLabel = '',
    color = 'primary',
    className = ''
}) {
    const colorClasses = {
        primary: 'bg-primary-subtle text-primary',
        success: 'bg-success-subtle text-success',
        warning: 'bg-warning-subtle text-warning',
        danger: 'bg-danger-subtle text-danger',
        info: 'bg-info-subtle text-info',
    };

    return (
        <motion.div
            className={`card border-0 shadow-sm h-100 ${className}`}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
        >
            <div className="card-body">
                <div className="d-flex align-items-start justify-content-between">
                    <div>
                        <p className="text-muted small mb-1 text-uppercase fw-semibold letter-spacing-1">{label}</p>
                        <h3 className="mb-0 fw-bold">{typeof value === 'number' ? value.toLocaleString() : value}</h3>
                        {trend !== null && (
                            <div className={`small mt-2 ${trend >= 0 ? 'text-success' : 'text-danger'}`}>
                                <i className={`bi ${trend >= 0 ? 'bi-arrow-up' : 'bi-arrow-down'} me-1`}></i>
                                {Math.abs(trend)}% {trendLabel}
                            </div>
                        )}
                    </div>
                    <div className={`rounded-3 p-3 ${colorClasses[color]}`}>
                        <i className={`bi ${icon} fs-4`}></i>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
